<template>
  <div class="recorderDrawer" :class="side" :style="'width:'+width+'px'">
    <slot/>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class RecorderDrawer extends Vue {
  @Prop({default: 'left'})
  public side!: string;

  @Prop({default: 320})
  public width!: number;
}
</script>

<style scoped lang="scss">
// floating card on the light background
.recorderDrawer {
  height: calc(100% - 32px);
  margin: 16px;
  flex: none;
  background: #FFF;
  border: solid 1px var(--light1);
  border-radius: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
</style>
